import { ArrowUpRight } from "lucide-react";
import { Reveal, SectionHead } from "./Reveal";

const SERVICES = [
  ["Site institucional", "Presença completa da sua marca: páginas bem estruturadas, conteúdo claro e uma identidade visual que transmite confiança desde o primeiro acesso."],
  ["Landing page", "Uma página focada em um único objetivo — apresentar um serviço, captar contatos ou divulgar uma campanha — com narrativa e chamada para ação diretas."],
  ["Loja virtual", "Vitrine digital para apresentar produtos com elegância, organizada para que o cliente encontre o que procura e chegue ao contato ou à compra."],
  ["Redesign", "Seu site atual repensado: nova direção visual, navegação mais simples e uma experiência à altura do nível da sua empresa hoje."],
];

export const Services = ({ onBrief }) => (
  <section id="servicos" data-testid="services-section" className="mx-auto max-w-[1440px] px-5 sm:px-8 lg:px-12 py-24 lg:py-40">
    <SectionHead index="01" label="Serviços" title={<>O que criamos para a <span className="font-serif italic font-normal text-gold">sua marca</span>.</>}>
      Cada projeto nasce da sua estratégia de negócio. Escolha o formato — o desenho é sempre autoral.
    </SectionHead>
    <ul className="border-t border-white/10">
      {SERVICES.map(([t, d], i) => (
        <Reveal as="li" key={t} delay={i * 0.06}>
          <button onClick={onBrief} data-testid={`service-row-${i}`} className="group w-full text-left grid grid-cols-[auto_1fr_auto] lg:grid-cols-12 gap-x-5 gap-y-3 items-start py-8 lg:py-10 border-b border-white/10 relative">
            <span className="absolute bottom-[-1px] left-0 h-px w-full bg-[#D4AF5A] origin-left scale-x-0 group-hover:scale-x-100 transition-transform duration-700" />
            <span className="font-mono text-xs text-gold pt-2 lg:col-span-1">0{i + 1}</span>
            <h3 className="font-display text-2xl sm:text-4xl font-semibold tracking-[-0.02em] lg:col-span-5 group-hover:translate-x-2 transition-transform duration-500">{t}</h3>
            <ArrowUpRight className="text-[#A7A7AD] group-hover:text-[#D4AF5A] group-hover:rotate-45 transition-[transform,color] duration-500 lg:order-last lg:col-span-1 lg:justify-self-end mt-2" size={22} />
            <p className="col-span-3 lg:col-span-5 text-[#A7A7AD] text-[15px] leading-relaxed pl-[calc(1.25rem+1.4ch)] lg:pl-0">{d}</p>
          </button>
        </Reveal>
      ))}
    </ul>
  </section>
);
